import { EAiPosition } from '../types/ai';

interface CalculateCoordinates {
  position: EAiPosition;
  imageDimensions: {
    height: number;
    width: number;
  };
  aiDimensions: {
    height: number;
    width: number;
  };
  aiIsText: boolean;
  offset?: number;
  offsetScale?: number;
}

export function calculateCoordinates({
  position,
  imageDimensions,
  aiDimensions,
  aiIsText,
  offset = 0,
  offsetScale = 0,
}: CalculateCoordinates) {
  const height = imageDimensions.height - aiDimensions.height;
  const width = imageDimensions.width - aiDimensions.width;
  const centerVertically = height / 2;
  const centerHorizontally = width / 2;

  const verticalStartOrigin = aiIsText ? aiDimensions.height * 3 + 10 : 0;

  const verticalEndOrigin = aiIsText
    ? height - aiDimensions.height * 2
    : height;

  const offsetX = offsetScale ? imageDimensions.width * offsetScale : offset;
  const offsetY = offsetScale ? imageDimensions.height * offsetScale : offset;

  const positions: Record<EAiPosition, { x: number; y: number }> = {
    [EAiPosition.TOP_LEFT]: {
      x: 0 + offsetX,
      y: verticalStartOrigin + offsetY,
    },
    [EAiPosition.TOP_CENTER]: {
      x: centerHorizontally,
      y: verticalStartOrigin + offsetY,
    },
    [EAiPosition.TOP_RIGHT]: {
      x: width - offsetX,
      y: verticalStartOrigin + offsetY,
    },

    [EAiPosition.CENTER]: { x: centerHorizontally, y: centerVertically },
    [EAiPosition.CENTER_LEFT]: { x: 0 + offsetX, y: centerVertically },
    [EAiPosition.CENTER_RIGHT]: {
      x: width - offsetX,
      y: centerVertically,
    },

    [EAiPosition.BOTTOM_CENTER]: {
      x: centerHorizontally,
      y: verticalEndOrigin - offsetY,
    },
    [EAiPosition.BOTTOM_LEFT]: {
      x: 0 + offsetX,
      y: verticalEndOrigin - offsetY,
    },
    [EAiPosition.BOTTOM_RIGHT]: {
      x: width - offsetX,
      y: verticalEndOrigin - offsetY,
    },
  };

  return positions[position];
}
